import { Title, TitleProps } from "@mantine/core";
import { ReactElement } from "react";

export default function CardTitle({
  children,
}: Omit<TitleProps, "c" | "order" | "size">): ReactElement {
  return (
    <Title c="gray.7" m={0} order={6} size="h5">
      {children}
    </Title>
  );
}
